<section  *ngIf="!commonService.commonMainObj.invalidUser">
    <div class="vh_center mt-4">
        <div col="12">
            <div style=" margin:0px; " class="vh_center">
                <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
                <div style="width:130px; height:5px; background-color: #fcb816;"></div>
                <img class=" " src="assets/img/c_yl.png" width="27" height="27" style=" float:left;" />
                <div style="width:130px; height:5px; background-color: #dadada;"></div>
                <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
                <div style="width:130px; height:5px; background-color: #dadada;"></div>
                <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
                <div style="width:130px; height:5px; background-color: #dadada;"></div>
                <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
            </div>
        </div>
      </div>
      <div class="vh_center mt-2">
        <div col="12">
          <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
            <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
            <div style="width:150px;  padding-left: 15px; background-color: #ffffff;">Quote</div>
            <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Order details</div>
            <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Review & Confirm</div>
            <div style="width:150px;   padding-left: 15px;  background-color: #ffffff;">Place order</div>
          </div>
        </div>
      </div>
    <div class="container">
        <h2 class="text-center header-title page_top_space mb-3"> <b>Additional Component Details</b> </h2>
        <div class="grey-border" style="padding: 15px; border-radius: 5px;">
            <div class="fs16 mt-3 text-center">As per industry-standard practices, we typically aqueous clean the boards after assembly.</div>
            <div class="row justify-content-center mt-4">
                <div class="col-5 text-right">
                    <div class="">Are there any components that <span>CANNOT</span> be aqueous cleaned</div>
                </div>
                <div class="col-6 text-left"> 
                    <div>
                        <select class="form-select" [(ngModel)]="commonService.commonMainObj.aqueousSelectOption" (change)="changeOption($event)">
                            <option value="">Choose</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center mt-5 mb-5" *ngIf="commonService.commonMainObj.aqueousSelectOption == 'Yes' ">
                <div class="col-5">
                    <div class="">If Yes, specify those components here</div>
                    <div *ngIf="commonService.commonMainObj.aqueousSelectOption == 'Yes' ">
                        <div class="custom-select">
                            <div class="select-box" (click)="toggleDropdown() ; preventCloseOnClick()">
                              <span style="font-size: 15px;">Select options</span>
                              <span class="arrow">▼</span>
                            </div>
                            
                            <div class="dropdown" id="dropDown" *ngIf="dropdownOpen" (click)="preventCloseOnClick()">
                              <div class="form-check option" *ngFor="let option of option">
                                <input id="{{option.component}}" class="form-check-input" type="checkbox" [(ngModel)]="option.selected" (change)="updateSelectedOptions()" />
                                <label class="form-check-label" for="{{option.component}}" style="width: 100%;">{{ option.component }}</label>
                              </div>
                            </div>
                          </div>
                    </div>
                </div>
                <div class="col-6 text-left"> 
                    <!-- <div class="text-left">
                        <select class="form-select" [(ngModel)]="components.selectedComponent" (change)="selectComponentsChange($event)">
                            <option value="">Select components</option>
                            <option *ngFor="let item of commonService.commonMainObj.allAvailableComponets" [value]="item">{{ item }}</option>
                        </select>
                    </div> -->
                    <div *ngIf="selectedOptions.length > 0 && commonService.commonMainObj.aqueousSelectOption == 'Yes'">
                        <div class="">Selected Components</div>
                        <div class="main-selected-sec">
                            <div class="selected-item" *ngFor="let selecteditem of selectedOptions">
                                <!-- <span class="" >{{selecteditem}}<span class="remove-btn" id="{{selecteditem}}" (click)="removeSelectedComponent(selecteditem)" >X</span> </span> -->
                                <span *ngIf="selectedOptions.length > 0">{{ selecteditem }}<span class="remove-btn" id="{{selecteditem}}" (click)="removeSelectedComponent(selecteditem)" >X</span></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="this.commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'" class="text-center mt-5 mb-5 procced-btn"><button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3" (click)="continueFromAdditional()">Proceed</button></div>
        <div *ngIf="this.commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'" class="text-center mt-5 mb-5 procced-btn"><button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3" (click)="continueFromAdditional()">Submit Custom Quote Request</button></div>
    </div>
</section>
<section class="mt-5" *ngIf="commonService.commonMainObj.invalidUser">
    <div class="vh_center mt-4">
        <div col="12">
            <div style=" margin:0px; " class="vh_center">
                <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
                <div style="width:130px; height:5px; background-color: #fcb816;"></div>
                <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
                <div style="width:130px; height:5px; background-color: #fcb816;"></div>
                <img class=" " src="assets/img/c_er.png" width="27" height="27" style=" float:left;" />
                <div style="width:130px; height:5px; background-color: #dadada;"></div>
                <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
                <div style="width:130px; height:5px; background-color: #dadada;"></div>
                <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
            </div>
        </div>
    </div>
    <div class="vh_center mt-2">
        <div col="12">
          <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
            <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
            <div style="width:150px;  padding-left: 15px; background-color: #ffffff;">Quote</div>
            <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Order details</div>
            <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Review & Confirm</div>
            <div style="width:150px;   padding-left: 15px;  background-color: #ffffff;">Place order</div>
          </div>
        </div>
    </div>
    <div class="text-center text-danger fw-b mt-5 fs-2">Sorry, this order cannot be placed.</div>
    <div class="text-center mt-4">
      Quote <b>{{commonService.commonMainObj.wqId}} </b> was generated with <b> {{commonService.commonMainObj.email}} </b> but you have signed in with <b> {{commonService.commonMainObj.loginEmail}} </b>
    </div>
    <div class="text-center mt-4">
      <p>
        Please restart the flow by clicking on ‘OK’ button and make sure to sign-in with the email id that was used to generate the quote.
      </p>
    </div>
    <div class="text-center mt-4">
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="commonService.goBack()"> <b>Ok</b>
      </button>
    </div>
</section>
